/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions';
import {
    instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSON,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped,
    FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON,
} from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions';

/**
 * @type FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames
 * 
 * @export
 */
export type FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames = FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions;

export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSON(json: any): FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames {
    return FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSON(json: any): any {
    return FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSONTyped(value?: FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON(value as FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions);
    }

    return {};
}

